import React, { memo, useEffect, useMemo, useState } from "react";
import { FlatList, StyleSheet, TouchableOpacity, useWindowDimensions, View, Text, ScrollView } from "react-native"
import CustomPressable from "../../components/customPressable/customPressable";
import { ImageComp } from "../../components/Image/Image";
import { ADD, CHEVRON_RIGHT, MINUS, PLUS } from "../../assets";
import { useTranslation } from "react-i18next";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useDispatch, useSelector } from "react-redux";
import { getCleanUrl } from "../../utils/Helper";
import { COLORS } from "../../style";
import CustomFlatList from "../../components/customFlatList";
import { HCOMMERCE } from "../../config/Constant";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import RenderHTML from "react-native-render-html";

export const StoreLevel1 = memo((props) => {

    const { storeData, handleStoreItemSubTypeSelect, cartItem, handleAddToCart, handleRemoveFromCart, handleItemInfo } = props || {};

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
      const { width } = useWindowDimensions()
    

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    
    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const [selectedStoreType, setSelectedStoreType] = useState({});

    const handleSelectStoreType = (selectedStoreType) => {

        setSelectedStoreType(selectedStoreType);

    };

    useEffect(()=>{
        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 1", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    // console.log("currentWidget", currentWidget, getCleanUrl(currentWidget?.widgetHeaderImageUrl));

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel1_itemContainer_textContainer_title']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const customWidgetSubTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_storelevel1_itemContainer_textContainer_subtitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    return (
        <View style={getStyles(['widgetmainContainer', 'hcommerce_storelevel1_MainContainer'])} id="widgetmainContainer hcommerce_storelevel1_MainContainer">

            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_storelevel1_HeaderImg'])} id={`widgetmainContainerHeaderImg hcommerce_storelevel1_HeaderImg`} />
            }
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_storelevel1_HeaderContainer'])} id="widgetmainContainerHeaderContainer hcommerce_storelevel1_HeaderContainer">
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_storelevel1_HeaderTitleContainer'])} id="widgetmainContainerHeaderTitleContainer hcommerce_storelevel1_HeaderTitleContainer">
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_storelevel1_HeaderTitle'])} id={`widgetmainContainerHeaderTitle hcommerce_storelevel1_HeaderTitle`}>{currentWidget.displayName}</Text>
                </View>
                <View style={getStyles(["hcommerce_storelevel1_MainContainerChildContainerPillContainer"])} id="hcommerce_storelevel1_MainContainerChildContainerPillContainer">

                    {storeData?.menu?.length > 0 &&
                        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['hcommerce_storelevel1_PillContainer'])} id="hcommerce_storelevel1_PillContainer" style={{ width: '100%' }}>
                            <CustomPressable onPress={() => handleSelectStoreType({})} style={getStyles(['hcommerce_storelevel1_Pill', !selectedStoreType.id && 'hcommerce_storelevel1_SelectedPill'])} id={`hcommerce_storelevel1_Pill hcommerce_storelevel1_SelectedPill`}>
                                <Text style={getStyles(['hcommerce_storelevel1_Pill_Text', !selectedStoreType.id && 'hcommerce_storelevel1_SelectedPill_Text'])} id={`hcommerce_storelevel1_Pill_Text hcommerce_storelevel1_SelectedPill_Text`}>{t('h-commerce.all')}</Text>
                            </CustomPressable>

                            {storeData?.menu.map((category) => (
                                <CustomPressable key={category.id} onPress={() => handleSelectStoreType(category)} style={getStyles(['hcommerce_storelevel1_Pill', selectedStoreType.id == category.id && 'hcommerce_storelevel1_SelectedPill'])} id={`hcommerce_storelevel1_Pill hcommerce_storelevel1_SelectedPill`}>
                                    <Text style={getStyles(['hcommerce_storelevel1_Pill_Text', selectedStoreType.id == category.id && 'hcommerce_storelevel1_SelectedPill_Text'])} id={`hcommerce_storelevel1_Pill_Text hcommerce_storelevel1_SelectedPill_Text_${category.id}`}>{category.typeName}</Text>
                                </CustomPressable>
                            ))}
                        </ScrollView>
                    }

                </View>
            </View>


            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainerChildContainer', 'hcommerce_storelevel1_MainContainerChildContainer'])} id="widgetmainContainerChildContainer hcommerce_storelevel1_MainContainerChildContainer">

                {storeData?.menu?.map((category) => {

                    const renderAll = !selectedStoreType.id;

                    if (renderAll || (selectedStoreType.id === category.id)) {
                        return (

                            <View style={getStyles(['hcommerce_storelevel1_ChildContainer'])}   id={`hcommerce_storelevel1_ChildContainer hcommerce_storelevel1_ChildContainer_${category.id}`} key={category.id}>
                                <Text style={getStyles(['hcommerce_storelevel1_ChildContainer_Title'])} id={`hcommerce_storelevel1_ChildContainer_Title hcommerce_storelevel1_ChildContainer_Title_${category.id}`} >{category.typeName}</Text>

                                {/* Render subcategories if they exist */}
                                {category.subMenu && category.subMenu.length > 0 && <View style={getStyles(['hcommerce_storelevel1_ChildContainer_items_container'])} id={`hcommerce_storelevel1_ChildContainer_items_container hcommerce_storelevel1_ChildContainer_items_container_${category.id}`}>
                                    {category.subMenu.map((subCategory) => {
                                        const imageUri = subCategory.storeItemTypeImages?.find(image => image.imageType === "LARGE")?.imagePath || subCategory.storeItemTypeImages?.[0]?.imagePath;

                                        return (
                                            <CustomPressable key={subCategory.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel1_itemContainer'])} id={`list_itemContainer hcommerce_storelevel1_itemContainer_${subCategory.id}`} onPress={() => handleStoreItemSubTypeSelect(subCategory)}>

                                                <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel1_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel1_itemContainer_image">
                                                    {imageUri &&
                                                        <ImageComp
                                                            source={getCleanUrl(imageUri)}
                                                            style={getStyles(["hcommerce_storelevel1_item_image"])}
                                                            id="hcommerce_storelevel1_item_image"

                                                        />
                                                    }
                                                </View>
                                                <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel1_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel1_itemContainer_textContainer">

                                                    <RenderHTML
                                                        contentWidth={width}
                                                        baseStyle={customWidgetTitleStyle}
                                                        source={{ html: subCategory.subTypeName}}
                                                        systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                        id={`list_itemContainer_textContainer_title hcommerce_storelevel1_itemContainer_textContainer_title_${subCategory.id}`}
                                                        defaultTextProps={{
                                                            numberOfLines: 1
                                                        }}
                                                    />


                                                    {subCategory.subTypeDescription &&
                                                        <RenderHTML
                                                            contentWidth={width}
                                                            baseStyle={customWidgetSubTitleStyle}
                                                            source={{ html: subCategory.subTypeDescription}}
                                                            systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                            id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${subCategory.id}`}
                                                            defaultTextProps={{
                                                                numberOfLines: 1
                                                            }}
                                                        />
                                                    }
                                                </View>

                                                <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_storelevel1_itemContainer_arrow'])} id={`list_itemContainer_arrow hcommerce_storelevel1_itemContainer_arrow_${subCategory.id}`}>
                                                    <ImageComp source={CHEVRON_RIGHT} />
                                                </View>
                                            </CustomPressable>
                                        );
                                    })}
                                </View>}

                                {/* Render items directly under category */}
                                {category.storeItem && category.storeItem.length > 0 && <View style={getStyles(['hcommerce_storelevel1_ChildContainer_items_container'])} id="hcommerce_storelevel1_ChildContainer_items_container">
                                    {category.storeItem.map((item) => {

                                        const totalQuantity = cartItem.reduce((total, cartItem) => {
                                            return cartItem.itemInfo.id === item.id ? total + cartItem.quantity : total;
                                        }, 0);

                                        // Determine if item has addons
                                        const hasItemAddOns = (item.addOnGroupReferences && item.addOnGroupReferences.length > 0) ||
                                                             (item.addOnItem && item.addOnItem.length > 0);

                                        const imageUri = item.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || item.storeItemImages?.[0]?.imagePath;
                                        return (
                                            <CustomPressable key={item.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel1_itemContainer'])} onPress={() => handleItemInfo({...item, hasItemAddOns})} id={`list_itemContainer hcommerce_storelevel1_itemContainer_${item.id}`}>

                                                <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel1_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel1_itemContainer_image">
                                                    {imageUri &&
                                                        <ImageComp
                                                            source={getCleanUrl(imageUri)}
                                                            style={getStyles(["hcommerce_storelevel1_item_image"])}
                                                            id="hcommerce_storelevel1_item_image"
                                                        />
                                                    }
                                                </View>
                                                <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel1_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel1_itemContainer_textContainer">
                                                    <RenderHTML
                                                        contentWidth={width}
                                                        baseStyle={customWidgetTitleStyle}
                                                        source={{ html: item.itemName}}
                                                        systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                        id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${item.id}`}
                                                        defaultTextProps={{
                                                            numberOfLines: 1
                                                        }}
                                                    />

                                                    {item.itemDescription &&
                                                        <RenderHTML
                                                            contentWidth={width}
                                                            baseStyle={customWidgetSubTitleStyle}
                                                            source={{ html: item.itemDescription}}
                                                            systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                            id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${item.id}`}
                                                            defaultTextProps={{
                                                                numberOfLines: 1
                                                            }}
                                                        />
                                                    }



                                                    <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_storelevel1_itemContainer_textContainer_tertiaryContainer'])} id="list_itemContainer_textContainer_tertiaryContainer hcommerce_storelevel1_itemContainer_textContainer_tertiaryContainer">

                                                        <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel1_itemContainer_textContainer_currencytitle'])} id={`list_itemContainer_textContainer_title hcommerce_storelevel1_itemContainer_textContainer_currencytitle`}>{currencyCode + item.itemPrice}</Text>

                                                        <View style={getStyles(['additem_controls'])} id="additem_controls">
                                                            {totalQuantity > 0 &&
                                                                <CustomPressable onPress={() => handleRemoveFromCart({...item, hasItemAddOns})} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                                    <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img" />
                                                                </CustomPressable>
                                                            }
                                                            {totalQuantity > 0 &&
                                                                <Text style={getStyles(['additem_controls_qty_text'])} id="additem_controls_qty_text" >{totalQuantity}</Text>
                                                            }
                                                            <CustomPressable onPress={() => handleAddToCart({...item, hasItemAddOns})} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                                <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img" />
                                                            </CustomPressable>

                                                        </View>

                                                    </View>
                                                </View>
                                            </CustomPressable>
                                        );
                                    })}
                                </View>}


                            </View>
                        );
                    }
                    return null;
                })}
            </ScrollView>
        </View>
    );
});

